import {
  UPLOAD_IMAGE_EVENT_REQUEST,
  UPLOAD_IMAGE_EVENT_SUCCESS,
  UPLOAD_IMAGE_EVENT_FAILURE,
  UPLOAD_IMAGE_EVENT,
} from "../../actions/events/upload-image-action";

const initialState = {
  upload: null,
  isLoading: false,
  error: null,
};

const EventUploadImageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPLOAD_IMAGE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case UPLOAD_IMAGE_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        upload: { ...action.payload },
      };
    case UPLOAD_IMAGE_EVENT:
      return {
        ...state,
        isLoading: false,
        upload: { ...action.payload },
      };
    case UPLOAD_IMAGE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default EventUploadImageReducer;
